import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, SectionHeader, TextBox } from '../common';
import { useAuth } from '../../contexts/AuthContext';

/** 국내번호를 E.164 형식으로 변환 (react-phone-number-input 호환) */
function toE164(phone) {
  if (!phone) return phone;
  let num = phone.replace(/[^\d+]/g, '');
  // 이미 E.164 형식이면 그대로
  if (num.startsWith('+')) return num;
  // 010... → +8210...
  if (num.startsWith('0')) num = '+82' + num.slice(1);
  return num;
}

/**
 * 예약자 정보 카드 — 모든 예약 페이지 공통
 * 로그인 상태면 유저 정보를 default로 채워줌 (수정 가능)
 */
export default function BookerInfoCard({ userName, setUserName, phone, setPhone, email, setEmail, emailError, phoneError }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const safeSetPhone = (val) => setPhone(toE164(val) || val);

  useEffect(() => {
    if (!user) return;
    if (user.name && !userName) setUserName(user.name);
    if (user.phone && !phone) safeSetPhone(user.phone);
    if (user.email && !email) setEmail(user.email);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Card>
      <SectionHeader variant="card" title={t('booking.guest_info')} />
      <TextBox
        label={<>{t('common.user_name')} <span className="text-orange-500">*</span></>}
        placeholder={t('common.user_name_placeholder')}
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        className="w-full lg:max-w-[240px]"
      />
      <div>
        <TextBox
          label={<>{t('common.phone_label')} <span className="text-orange-500">*</span></>}
          variant="phone"
          value={phone}
          onChange={(value) => setPhone(value ?? '')}
          className="w-full lg:max-w-[320px]"
          error={phoneError}
        />
      </div>
      <TextBox
        label={<>{t('common.email_label')} <span className="text-orange-500">*</span></>}
        placeholder={t('common.email_placeholder_example')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full lg:max-w-[280px]"
        error={emailError}
      />
      <p className="text-2sm font-medium text-orange-500">{t('common.international_notice')}</p>
    </Card>
  );
}
